var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoLive1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#0099FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4419 38.664V54.6635M38.4422 46.6637H54.4417M25.6426 60.263V26.6642C25.6426 25.8155 25.9797 25.0016 26.5798 24.4015C27.1799 23.8014 27.9938 23.4642 28.8425 23.4642H40.6501C41.3811 23.443 42.0973 23.6727 42.6795 24.1152C43.2617 24.5576 43.6748 25.1862 43.85 25.8962L44.842 29.8641H64.0414C64.89 29.8641 65.7041 30.2012 66.304 30.8013C66.904 31.4014 67.2413 32.2153 67.2413 33.064V60.263C67.2413 61.1119 66.904 61.9257 66.304 62.5256C65.7041 63.1259 64.89 63.4629 64.0414 63.4629H28.8425C27.9938 63.4629 27.1799 63.1259 26.5798 62.5256C25.9797 61.9257 25.6426 61.1119 25.6426 60.263Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoLive1);
export default __webpack_public_path__ + "static/media/go_live_1.8c7e0e9c38ada4729a508c3327d2360d.svg";
export { ForwardRef as ReactComponent };